import {Controller} from "@hotwired/stimulus"

// Swaps the page title row for a search field and back.
//
// Découvrir is a card feed on a phone: a search box parked permanently under the tabs
// cost roughly a card's worth of height on every visit, for something reached
// occasionally. So the field lives behind the header's magnifier icon instead, and
// takes the title row's place only while it is in use.
//
// It also fixes the thing a collapsed search usually breaks: because the field is
// re-rendered open whenever the URL carries a term, the caret comes back after each
// auto-submit instead of the keyboard closing on every keystroke.
export default class extends Controller {
    static targets = ["bar", "panel", "input", "form"]
    static values = {open: Boolean}

    connect() {
        this.render()
    }

    open(event) {
        event.preventDefault()
        this.openValue = true
    }

    // Closing with a term on screen has to actually drop the search, not just hide the
    // field — otherwise the list underneath stays filtered by a query nobody can see.
    close(event) {
        event.preventDefault()

        if (this.hasInputTarget && this.inputTarget.value.trim() !== "") {
            this.inputTarget.value = ""
            this.formTarget.requestSubmit()
            return
        }

        this.openValue = false
    }

    closeOnEscape(event) {
        if (event.key === "Escape") this.close(event)
    }

    openValueChanged() {
        this.render()
    }

    render() {
        if (!this.hasBarTarget || !this.hasPanelTarget) return

        this.barTarget.classList.toggle("hidden", this.openValue)
        this.panelTarget.classList.toggle("hidden", !this.openValue)

        if (!this.openValue || !this.hasInputTarget) return

        this.inputTarget.focus()
        const length = this.inputTarget.value.length
        this.inputTarget.setSelectionRange(length, length)
    }
}
